import createMenuItemFromResource from '@/classes/createMenuItems';
import http from '../../http';
import urlFormatter from '../../url-formatter';

const getURL = urlFormatter({
  list: '/api/v1/admin/custom-menu-items',
  delete: '/api/v1/admin/custom-menu-items/{id}/delete',
  update: '/api/v1/admin/custom-menu-items/{id}',
});

export default {
  list() {
    const endpoint = getURL('list');

    return http
      .get(endpoint)
      .then((response) => response.data.data.map(createMenuItemFromResource));
  },

  remove(serverId) {
    const endpoint = getURL('delete', { id: serverId });

    return http.post(endpoint);
  },

  create(payload) {
    const endpoint = getURL('list');

    return http.post(endpoint, payload)
      .then((response) => createMenuItemFromResource(response.data.data))
      .catch((error) => {
        error.errors = error?.response?.data?.errors || null;
        throw error;
      });
  },

  update(serverId, payload) {
    const endpoint = getURL('update', { id: serverId });

    return http.put(endpoint, payload)
      .then((response) => createMenuItemFromResource(response.data.data))
      .catch((error) => {
        error.errors = error?.response?.data?.errors || null;
        throw error;
      });
  },

  getURL,
};
